import { render } from "./ProfileUserInfo.vue?vue&type=template&id=6715092f"
import script from "./ProfileUserInfo.vue?vue&type=script&lang=js"
export * from "./ProfileUserInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__